import { useQuery } from '@tanstack/react-query'
import {
  accessControlApi,
  type AuditLogQuery,
} from '../api/access-control.client'

export const auditLogQueryKey = (params: AuditLogQuery) =>
  ['access-control', 'audit-log', params] as const

export function useAuditLogQuery(params: AuditLogQuery) {
  return useQuery({
    queryKey: auditLogQueryKey(params),
    queryFn: () => accessControlApi.getAuditLog(params),
    retry: false,
    refetchOnWindowFocus: false,
  })
}
